import React from 'react';
import styled from 'styled-components';
import { CustomerNumber } from '../../types';
import { calculateCreditRemaining } from '../../utils/customer-number';
import ArrowLeftIcon from '../common/Icons/ArrowLeft';
import UserAvatar from '../common/UserAvatar';

export interface ActiveCustomerNumberProps extends React.HTMLAttributes<HTMLDivElement> {
    activeNumber: CustomerNumber;
    totalOwnedNumber: number;
}

const StyledActiveCustomerNumber = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    padding: 1rem;
    align-items: center;

    .avatar {
        width: 28px;
        height: 28px;
    }

    .avatar svg {
        width: 20px;
        height: 20px;
    }

    .number-detail {
        margin-left: 1rem;
        flex-grow: 1;
    }
    .number {
        color: var(--text-primary);
        font-size: 0.875rem;
        font-weight: 400;
    }
    .credit-balance {
        color: #000000;
        font-size: 1rem;
        font-weight: 600;
        line-height: 1.725rem;
    }

    .arrow-icon {
        transform: rotate(180deg);
        width: 10px;
        height: 12px;
    }
`;

const ActiveCustomerNumber: React.FC<ActiveCustomerNumberProps> = ({
    activeNumber,
    totalOwnedNumber,
    ...props
}) => {
    const getCustomerNumberText = (customerNumber: CustomerNumber) => {
        // return customerNumber.creditType === 'Guest' ? 'Guest' : customerNumber.number;
        return customerNumber.number;
    };

    const getCustomerCreditText = (customerNumber: CustomerNumber) => {
        switch (customerNumber.creditType) {
            case 'Guest':
                return 'Guest - Free';
            case 'Credit-Group':
                return `${calculateCreditRemaining(customerNumber)} minutes`;
            case 'Credit-Plan':
            default:
                return `${calculateCreditRemaining(customerNumber)} minutes`;
        }
    };
    return (
        <StyledActiveCustomerNumber {...props}>
            <div className="avatar-container">
                <UserAvatar className="avatar" />
            </div>
            <div className="number-detail">
                <div className="number">{getCustomerNumberText(activeNumber)}</div>
                <div className="credit-balance">{getCustomerCreditText(activeNumber)}</div>
            </div>
            {totalOwnedNumber > 1 && <ArrowLeftIcon className="arrow-icon" aria-label="Open Phone Number or Account Dialog"/>}
        </StyledActiveCustomerNumber>
    );
};

export default ActiveCustomerNumber;
